import { memo } from 'react';

import NavigationButton from './NavigationButton.jsx';
import PageLink from './PageLink.jsx';

const PageLinks = memo(function PageLinks({
  currentPage,
  firstPageVisible,
  isDisabled,
  lastPageVisible,
  nextBtnAriaLabel,
  nextBtnTextCondensed,
  nextBtnTextExpanded,
  onLinkClick,
  onNextClick,
  onPrevClick,
  totalPages,
  pageLinkAriaLabel,
  prevBtnAriaLabel,
  prevBtnTextCondensed,
  prevBtnTextExpanded,
  useButtons,
}) {
  let pages = [];
  for (let i = 1; i <= totalPages; i += 1) {
    pages.push(i);
  }

  return (
    <>
      {/* Previous button */}
      <NavigationButton
        btnAriaLabel={prevBtnAriaLabel}
        btnTextCondensed={prevBtnTextCondensed}
        btnTextExpanded={prevBtnTextExpanded}
        btnType="prev"
        currentPage={currentPage}
        isDisabled={isDisabled}
        onPrevClick={onPrevClick}
        onNextClick={onNextClick}
        totalPages={totalPages}
        useButtons={useButtons}
      />

      {/* Page links */}
      {pages.map((page, idx) => {
        if (page <= lastPageVisible && page >= firstPageVisible) {
          return (
            <PageLink
              currentPage={currentPage}
              key={idx}
              isDisabled={isDisabled}
              onLinkClick={onLinkClick}
              page={page}
              pageLinkAriaLabel={pageLinkAriaLabel}
              useButtons={useButtons}
            />
          );
        }
        return null;
      })}

      {/* Next button */}
      <NavigationButton
        btnAriaLabel={nextBtnAriaLabel}
        btnTextCondensed={nextBtnTextCondensed}
        btnTextExpanded={nextBtnTextExpanded}
        btnType="next"
        currentPage={currentPage}
        isDisabled={isDisabled}
        onPrevClick={onPrevClick}
        onNextClick={onNextClick}
        totalPages={totalPages}
        useButtons={useButtons}
      />
    </>
  );
});

export default PageLinks;
